<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">
            <div class="page-content">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-sm-6">
                            <h3 class="breadcrumb-title m-0 pe-3"><span [translate]="'GREATER.FINANCIALS'"> </span></h3>
                        </div>
                        <div class="col-12 col-sm-6 position-relative">
                            <div class="followers-filter-box">
                                <ul>
                                    <li>
                                        <a href="javascript:void(0);" id="week" (click)="filters='week';getPurchase()"> Week </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" id="month" class="active"  (click)="filters='month';getPurchase()"> Month </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" id="year" (click)="filters='year';getPurchase()"> Year </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->

                <section class="inner-section-wrap pb-4">
                    <div class="tab-wrap">
                        <div class="tab-header border-bottom">
                            <div class="d-flex justify-content-start">
                                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" id="pills-standard-tab" data-bs-toggle="pill" data-bs-target="#Standardtab" type="button" role="tab" aria-controls="pills-standard" aria-selected="false" (click)="types='revenue';getPurchase();viewshows=false"><span [translate]="'GREATER.REVENUE'"> </span></button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="pills-nutrition-tab" data-bs-toggle="pill" data-bs-target="#Nutritiontab" type="button" role="tab" aria-controls="pills-nutrition" aria-selected="true" (click)="types='breakdown';getPurchase();viewshows=true"><span [translate]="'GREATER.BREAKDOWN'"> </span></button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="tab-content tab-content-secound" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="Standardtab" role="tabpanel" aria-labelledby="pills-standard-tab" >
                                <div class="site-content-block row pt-5">                                    
                                    <div class="col-12">
                                        <div class="tab-wrap">
                                            <div class="row align-items-center" >
                                                <div class="col-12 pb-3">
                                                    <div class="row text-center">
                                                        <div class="col-md-2">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">Subscriptions</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{subs_val}}</h6>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                   
                                                        <div class="col-md-2">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">Programs</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{pro_val}}</h6>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                     
                                                        <div class="col-md-2">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">Referral</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{ref_val}}</h6>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">Collaboration</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{coll_val}}</h6>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">Cancellations</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{can_val}}</h6>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-7" >
                                                    <canvas baseChart class="chart" [data]="lineChartData" [options]="lineChartOptions" [type]="'line'" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)" *ngIf="chartShow"></canvas>
                                                </div>
                                                <div class="col-12 col-sm-5">
                                                    <div class="card">
                                                        <div class="dashboard-chartbox-img transparent-bg border-radius20" *ngIf="!donutShow">
                                                            <img src="../../../assets/images/financials.svg" />
                                                        </div>
                                                        <div class="dashboard-chartbox border-radius20 imgvid-contain" >
                                                            <canvas baseChart class="chart" [data]="doughnutChartData" [type]="'doughnut'" [options]="chartOptions"  [plugins]="doughnutChartPlugins" *ngIf="donutShow"></canvas>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                            <div class="tab-pane fade" id="Nutritiontab" role="tabpanel" aria-labelledby="pills-nutrition-tab" >
                                <div class="site-content-block row pt-5">                                    
                                    <div class="col-12">
                                        <div class="tab-wrap">
                                            <div class="row align-items-center" >
                                                <div class="col-12 pb-3">
                                                    <div class="row text-center">
                                                        <div class="col-md-3">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">Last month's sales</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{pre_amt}}</h6>
                                                                            
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">This month's sales</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{cur_amt}}</h6>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">Variance</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{var_amt}}</h6>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="card dark-bg w-100 py-1 my-2">
                                                                <a class="white-color">
                                                                    <div class="card-body">
                                                                        <div class="row align-items-center">
                                                                            <div class="col-12">
                                                                                <p class="mb-0 white-color font-12 font-w-normal">Variance </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex py-3 align-items-center">
                                                                            <h6 class="ps-3 title white-color m-0 font-w-normal">{{var_per}}
                                                                            <!-- <h3  class="text-success ms-5"> -->
                                                                                <i class="fa-solid fa-arrow-up text-success ms-5 me-5" *ngIf="var_typ=='positive'"></i>
                                                                                <i class="fa-solid fa-arrow-down text-danger ms-5 me-5" *ngIf="var_typ!='positive'"></i>
                                                                            <!-- </h3> -->

                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                      
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12" >
                                                    <canvas baseChart class="chart" [data]="barChartData" [options]="barChartOptions" [type]="'line'" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)" *ngIf="chartShow"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>

                        </div>

                    </div>
                
                </section>

                <section class="inner-section-wrap p-4 dark-bg border-radius20" *ngIf="!viewshows">
                    <div class="section-heading pb-3">

                        <div class="row align-items-center">
                            <div class="col-12 col-sm-6">
                                <h4 class="title pe-3">
                                    <span [translate]="'GREATER.RECENT_SALES'"> </span>
                                </h4>
                            </div>
                            <div class="col-12 col-sm-6 position-relative">
                                <div class="d-flex align-items-center justify-content-end">
                                    <a href="javascript:void(0);" class="ic-fill-btn btn action-btn">
                                        <!-- <i class="fa-solid fa-calendar-days"></i> -->
                                        <input matInput [matDatepicker]="picker" class="d-none"  (dateChange)="getData($event)">
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"  >
                                            <mat-icon matDatepickerToggleIcon>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 11H8V13H6V11ZM6 15H8V17H6V15ZM10 11H18V13H10V11ZM10 15H15V17H10V15Z"></path></svg>
                                            </mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </a>
                                    <a  href="javascript:void(0);" (click)="getData('')"> <i class="gricon gr_ic_close"></i></a>
                                    <!-- <mat-form-field >
                                        <mat-label>Choose a date</mat-label>
                                        <input matInput [matDatepicker]="picker" class="d-none">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                      </mat-form-field> -->
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="table-wrap">
                        <!-- Table Start -->
                        <div class="table-responsive table-block">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>. </th>
                                        <th scope="col"><span [translate]="'GREATER.DATE'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.TYPE'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.TRANSACTION_ID'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.AMOUNT'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.TITLE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span> </th>

                                    </tr>
                                </thead>
                                <tbody *ngIf="PurchaseList.length !=0">
                                    <tr *ngFor="let item of PurchaseList | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <th scope="row">
                                            {{i+1}}
                                        </th>
                                        <td>{{service.convertDate(item.createdAt)}}</td>
                                        <td>{{typeLabel(item)}}</td>
                                        <td>{{item.txnUniqueId}}</td>
                                        <td>{{loginDetail.userCurrencySymbol }} {{item.amounts}}</td>
                                        <td>{{titleLabel(item)}}</td>
                                        <td>{{statusLabel(item)}}</td>

                                    </tr>
                                </tbody>
                                <tbody *ngIf="PurchaseList.length ==0">
                                    <tr class="white-color text-center">No Record Found</tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-4">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="PurchaseList.length > 0"></pagination-controls>

                            </div>

                        </div>
                        <!-- Table End -->
                    </div>
                </section>

                <section class="inner-section-wrap p-4 dark-bg border-radius20" *ngIf="viewshows">
                    <div class="section-heading pb-3">

                        <div class="row align-items-center">
                            <div class="col-12 col-sm-6">
                                <h4 class="title pe-3">
                                    <span [translate]="'GREATER.TRANSACTION'"> </span>
                                </h4>
                            </div>
                            <div class="col-12 col-sm-6 position-relative">
                                <div class="d-flex align-items-center justify-content-end">
                                    <a href="javascript:void(0);" class="ic-fill-btn btn action-btn">
                                        <!-- <i class="fa-solid fa-calendar-days"></i> -->
                                        <input matInput [matDatepicker]="picker" class="d-none"  (dateChange)="getData($event)">
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"  >
                                            <mat-icon matDatepickerToggleIcon>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 11H8V13H6V11ZM6 15H8V17H6V15ZM10 11H18V13H10V11ZM10 15H15V17H10V15Z"></path></svg>
                                            </mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </a>
                                    <a  href="javascript:void(0);" (click)="getData('')"> <i class="gricon gr_ic_close"></i></a>
                                    <!-- <mat-form-field >
                                        <mat-label>Choose a date</mat-label>
                                        <input matInput [matDatepicker]="picker" class="d-none">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                      </mat-form-field> -->
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="table-wrap">
                        <!-- Table Start -->
                        <div class="table-responsive table-block">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>. </th>
                                        <th scope="col"><span [translate]="'GREATER.DATE'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.TYPE'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.TRANSACTION_ID'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.AMOUNT'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.TITLE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span> </th>

                                    </tr>
                                </thead>
                                <tbody *ngIf="TransactionList.length !=0">
                                    <tr *ngFor="let item of TransactionList | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <th scope="row">
                                            {{i+1}}
                                        </th>
                                        <td>{{service.convertDate(item.createdAt)}}</td>
                                       <td>{{typeLabel(item)}}</td>
                                        <td>{{item.txnUniqueId}}</td>
                                        <td>{{loginDetail.userCurrencySymbol }} {{item.amounts}}</td>
                                        <td>{{titleLabel(item)}}</td>
                                        <td>{{statusLabel(item)}}</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="TransactionList.length ==0">
                                    <tr class="white-color text-center">No Record Found</tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-4">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="TransactionList.length > 0"></pagination-controls>
                            </div>

                        </div>
                        <!-- Table End -->
                    </div>
                </section>
                <!-- Section Wrap End -->



            </div>
        </div>

    </div>
    <app-footer></app-footer>
</main>